
/**
 * Empty propagator, real propagator should be inherited from this class
 */
export class Propagator {
	get id() { return "0"; }
	set id(value) {}
	get title() { return ""; }
	set title(value) {}
	propagate(data) {}

	/**
	 * @param data
	 */
	fullPropagate(data) {
		let dataValue;
		if (typeof data.id === "string") dataValue = data.id;
		else dataValue = data.id.main;
		this.id = dataValue;
		let theTitle;
		if (typeof data.title === "string") theTitle = data.title;
		else theTitle = data.title.main;
		this.title = theTitle;
		this.propagate(data);
	}
}


export class StandardPropagator extends Propagator {
	constructor(pkInput, queryInput, propagatingFunction) {
		super();
		this.pkInput = pkInput;
		this.queryInput = queryInput;
		if (typeof propagatingFunction === 'function') this.propagator = propagatingFunction;
	}

	get styleId() {
		return this.pkInput.attr("id");
	}

	get id() {
		return this.pkInput.val();
	}

	set id(value) {
		this.pkInput.val(value);
	}

	get title() {
		return this.queryInput.val();
	}

	set title(value) {
		this.queryInput.val(value);
	}

	propagate(data) {
		if (this.propagator !== null && typeof this.propagator === 'function') this.propagator(data);
	}
}
